import React from "react";
import { Link } from "react-router-dom";

const Header = ({ handleToggle }) => {
  return (
    <header>
      <div className="topbar d-flex align-items-center">
        <nav className="navbar navbar-expand gap-3">
          {/* Mobile Menu Toggle */}
          <div className="mobile-toggle-menu" onClick={handleToggle}>
            <i className="bx bx-menu"></i>
          </div>

          {/* Dashboard Title */}
          <h2>Dashboard</h2>

          {/* Top Menu / Notifications */}
          <div className="top-menu ms-auto">
            <ul className="navbar-nav align-items-center gap-1">
              <li className="nav-item dropdown dropdown-large">
                <Link
                  className="nav-link dropdown-toggle dropdown-toggle-nocaret position-relative"
                  to="#"
                  data-bs-toggle="dropdown"
                >
                  <span className="alert-count">7</span>
                  <i className="bx bx-bell"></i>
                </Link>

                <div className="dropdown-menu dropdown-menu-end">
                  {/* Header */}
                  <div className="msg-header d-flex justify-content-between align-items-center px-3 py-2">
                    <p className="msg-header-title mb-0">Notifications</p>
                    <p className="msg-header-badge mb-0">5 New</p>
                  </div>

                  {/* Notifications List */}
                  <div className="header-notifications-list">
                    <Link className="dropdown-item" to="#">
                      <div className="d-flex align-items-center">
                        <div className="flex-grow-1">
                          <h6 className="msg-name">
                            New User Signup
                            <span className="msg-time float-end">Just now</span>
                          </h6>
                          <p className="msg-info mb-0">
                            A new user has successfully signed up on the platform and may require verification.
                          </p>
                        </div>
                      </div>
                    </Link>

                    <Link className="dropdown-item" to="#">
                      <div className="d-flex align-items-center">
                        <div className="flex-grow-1">
                          <h6 className="msg-name">
                            Package Subscribed
                            <span className="msg-time float-end">3 min ago</span>
                          </h6>
                          <p className="msg-info mb-0">
                            User has subscribed to a package and now has access to its features and benefits.
                          </p>
                        </div>
                      </div>
                    </Link>

                    <Link className="dropdown-item" to="#">
                      <div className="d-flex align-items-center">
                        <div className="flex-grow-1">
                          <h6 className="msg-name">
                            Support Request
                            <span className="msg-time float-end">10 min ago</span>
                          </h6>
                          <p className="msg-info mb-0">
                            User has submitted a support request and is awaiting assistance.
                          </p>
                        </div>
                      </div>
                    </Link>

                    <Link className="dropdown-item" to="#">
                      <div className="d-flex align-items-center">
                        <div className="flex-grow-1">
                          <h6 className="msg-name">
                            Policy Violation
                            <span className="msg-time float-end">1 hr ago</span>
                          </h6>
                          <p className="msg-info mb-0">
                            User has been reported for potential policy violation and requires review.
                          </p>
                        </div>
                      </div>
                    </Link>
                  </div>

                  {/* Footer Button (Optional) */}
                  {/* <div className="text-center msg-footer p-2">
                    <button className="btn btn-primary w-100">View All Notifications</button>
                  </div> */}
                </div>
              </li>
            </ul>
          </div>

          {/* User Profile Dropdown */}
          <div className="user-box dropdown px-3">
            <Link
              className="d-flex align-items-center nav-link dropdown-toggle gap-3 dropdown-toggle-nocaret"
              to="#"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <img src="images/avatars/avatar-2.png" className="user-img" alt="user avatar" />
              <div className="user-info">
                <p className="user-name mb-0">Pauline Seitz</p>
                <p className="designattion mb-0">Super Admin</p>
              </div>
            </Link>

            <ul className="dropdown-menu dropdown-menu-end">
              <li>
                <Link className="dropdown-item d-flex align-items-center" to="/profile">
                  <i className="bx bx-user fs-5"></i>
                  <span>Profile</span>
                </Link>
              </li>
              <li>
                <Link className="dropdown-item d-flex align-items-center" to="/settings">
                  <i className="bx bx-cog fs-5"></i>
                  <span>Settings</span>
                </Link>
              </li>
              <li>
                <div className="dropdown-divider mb-0"></div>
              </li>
              <li>
                <Link className="dropdown-item d-flex align-items-center" to="#" data-bs-toggle="modal" data-bs-target="#logoutModal">
                  <i className="bx bx-log-out-circle"></i>
                  <span>Logout</span>
                </Link>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
